import { useEffect, useRef } from "react";
import gsap from "gsap";

const useAnimatedAppearence = ({ isEnabled = true } = {})  => {
    const animatedContainerRef = useRef(null);

    useEffect(() => {
        if (!isEnabled) return;

        if (animatedContainerRef.current) {
            gsap.fromTo(
                animatedContainerRef.current,
                { autoAlpha: 0, y: 30 },
                { autoAlpha: 1, y: 0, duration: 0.6, ease: "power2.out" }
            );
        }
    }, [isEnabled]);

    return { animatedContainerRef }
}

export default useAnimatedAppearence;